<template>
  <div class="header">
    <!-- <a href="https://vcbeat.top"></a> -->
    <img :src="$store.state.static_img_url+'pic/logo.png'" @click="go" v-if="logo_vbeat">
    <img :src="$store.state.static_img_url+'pic/logo-vcbeat.png?v='+ $store.state.version" v-else>
    <!-- <p @click="quit">退出(测试用)</p> -->
    <i v-if="!on" class="iconfont" @click="change">&#xe6c1;</i>
    <i v-if="on" class="iconfont" @click="change">&#xe6c2;</i>
  </div>
</template>

<script>
import { loginOut } from '../service'
export default {
  inject: ['reload'],
  props: ['on'],
  computed: {
    logo_vbeat(){ // 页面是否使用vbeat logo
      const header_logo_vbeat = ['MLive']
      return header_logo_vbeat.indexOf(this.$route.name) == -1 ? true : false
    }
  },
  methods: {
    change() {
      this.$emit('change')
    },
    go() {
      // window.location.href = 'https://vcbeat.top'
      this.$router.push({name: 'MNotOpen'})
    },
    async quit() {
      let res = await loginOut({user_key: this.$store.state.user_key}, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$Message.success('退出成功！')
        this.$store.commit('updateUser', '')
        this.$store.commit('updateUserKey', '')
        // localStorage.clear()
        window.localStorage.removeItem('timestamp_left')
        window.localStorage.removeItem('timestamp_right')
        window.localStorage.removeItem('user')
        window.localStorage.removeItem('user_key')
        // this.$router.replace({name: 'SpecialList'})
        this.reload()
      } else {
        this.$Message.error(res.message)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.header
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  height: 1rem;
  width: 100%;
  padding: .28rem;
  border-bottom: 1px #E9E9E9 solid;
  transition: all .3s;
  z-index: 1000;
  background: #fff;
  img
    height: .6rem;
  // a
  //   background-repeat: no-repeat;
  //   background-image: url(../../../../public/logo.png);
  //   height: .6rem;
  //   width: 1.8rem;
  //   background-size: 100% 100%;
  i
    font-size: .48rem
  &.on
    transform: translateX(-3.2rem);
</style>
